import { Routes } from '@angular/router';
import { LoginPageComponent } from './login-page/login-page.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { RedirectComponent } from './redirect/redirect.component';
import { ResetPwdComponent } from './reset-pwd/reset-pwd.component';

export const routes: Routes = [
  { path: '', component: LoginPageComponent },
  { path: 'redirect', component: RedirectComponent },
  {
    path: 'accueil',
    component: LandingPageComponent,
  },
  { path: 'reset-pwd/:userToken', component: ResetPwdComponent },
];
